<template>
  <div class="produits-container">
    
    <div class="produits">
      
      <h1 class="produits-title">Réactifs Produits</h1>
    
      <!-- Breadcrumb -->
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a> > <a href="/reactifs">Réactifs Produits</a>
      </div>

      <!-- Tableau des réactifs -->
      <h2>Test Rapide</h2>
      <table class="reactifs-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reactif in reactifs" :key="reactif.code">
            <td>{{ reactif.code }}</td>
            <td>{{ reactif.article }}</td>
            <td>{{ reactif.cdt }}</td>
          </tr>
        </tbody>
      </table>
         <!-- Tableau des cartes gel -->
      <h2>Cartes Gel</h2>
      <table class="cartes-gel-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in cartesGel" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>
              <!-- Tableau de groupage -->
      <h2>Groupage</h2>
      <table class="gropage-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in groupage" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>
                    <!-- Tableau de serologie -->
      <h2>Serologie</h2>
      <table class="serologie-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in serologie" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>
                       <!-- Tableau biochimie -->
      <h2>Biochimie</h2>
      <table class="biochmie-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in biochimie" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>
                             <!-- Tableau C o a g u l a t i o n L ' h e m o s t a s e -->
      <h2>Coagulation L'hemostase</h2>
      <table class="Coagulation L'hemostase-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Article</th>
            <th>Conditionnement (CDT)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carte in Coagulation" :key="carte.code">
            <td>{{ carte.code }}</td>
            <td>{{ carte.article }}</td>
            <td>{{ carte.cdt }}</td>
          </tr>
        </tbody>
      </table>


    </div>
  </div>
</template>

<script>
export default {
  name: 'ReactifsI',
  data() {
    return {
      reactifs: [
        { code: 'HBSCWB40', article: 'AG HBS', cdt: '40 TESTS' },
        { code: 'HCVC0040', article: 'HCV', cdt: '40 TESTS' },
        { code: 'HIV00040', article: 'HIV', cdt: '40 TESTS' },
        { code: 'HCGCSU40', article: 'BETA HCG', cdt: '40 TESTS' },
        { code: 'HAVIGM40', article: 'HAV IGM', cdt: '40 TESTS' },
        { code: 'RPC0020', article: 'CHLAMYDIA AG', cdt: '20 TESTS' },
        { code: 'FOBC0020', article: 'FOB-OCCULT BLOOD', cdt: '20 TESTS' },
        { code: 'TPC0020', article: 'SYPHILIS', cdt: '20 TESTS' },
        { code: 'URS00100', article: 'BANDELETTE URINE 11 P', cdt: '10 TESTS' },
        { code: 'DOAC0006', article: 'MULTI DRUG 6 P', cdt: '20 TESTS' },
        { code: 'DOAC0012', article: 'MULTI DRUG 12 P DEVICE URINE', cdt: '20 TESTS' },
        { code: 'HPYFC020', article: 'H PYLORI AG', cdt: '20 TESTS' },
        { code: 'HPYC020', article: 'H PYLORI AC', cdt: '20 TESTS' },
        { code: 'HPYCF040', article: 'H PYLORI AC', cdt: '40 TESTS' },
        { code: 'HPYC0040', article: 'H PYLORI AC', cdt: '40 TESTS' }
      ],
        cartesGel: [
        { code: 'BGGCFRG1-25', article: 'ADULTE', cdt: '25 CARDS' },
        { code: 'BGGCFG01-25', article: 'DOUBLE ADULTE', cdt: '25 CARDS' },
        { code: 'BGGCNE0G-25', article: 'DIRECT NOUVEAU NEE', cdt: '25 CARDS' },
        { code: 'BGGCAHGG-25', article: 'RAI COOMBS DIRECT/INDIRECT', cdt: '25 CARDS' },
        { code: 'BGGCL100-150', article: 'LISS DILUANT', cdt: '150 ML' },
        { code: 'BGGCRHPK-25', article: 'CARTE  RH PHENOTYPE+K', cdt: '25 CARDS' },
        { code: 'BGGCS123', article: 'CELL SCREEN .HEMATIES', cdt: '1-2-3 3*5ML' }
      ],
        groupage: [
        { code: 'F/BGA00010', article: 'ANTI-A', cdt: '10 ML' },
        { code: 'F/BGAB00010', article: 'ANTI-AB', cdt: '10 ML' },
        { code: 'F/BGAG0010', article: 'AHG COOMBS', cdt: '10 ML' },
        { code: 'F/BGB00010', article: 'ANTI-B', cdt: '10 ML' },
        { code: 'F/BGD00010', article: 'ANTI-D', cdt: '10 ML' },
    
      ],
        serologie: [
        { code: 'LXASO10', article: 'ASLO Latex', cdt: '150 TEST' },
        { code: 'LXCRP150', article: 'CRP Latex', cdt: '150 TEST' },
        { code: 'LXRF150', article: 'RF Latex', cdt: '150 TEST' },
        { code: 'LXTX0100', article: 'TOXOPLASMOSIS', cdt: '100 TEST' },
        { code: 'SYCA0005', article: 'VDRL CARBON  250 TESTS', cdt: '5 ml' },
        { code: 'SYTP0200', article: 'TPHA', cdt: '200 TEST' },
        { code: 'SYRPR050', article: 'VDRL 50 TEST AVEC CONTROL -/+', cdt: '50 TEST' },
    
      ],
        biochimie: [
        { code: 'BXC0672A', article: 'HBA1C (L.S) DIRECT ENZYMATIC', cdt: 'R1: 1X7 ML, R2:1X3ML, R3:1X4.5 ML, R4: 1X15' },
          { code: 'BXC0563D', article: 'AMYLAS(L.S) EPS-PNPG7', cdt: 'R1: 1x100ML, R2: 1x20ML' },
          { code: 'BXC0123B', article: 'UREA (L.S) GLDH KINETIC,ENDPOINT', cdt: 'R1: 3x100 ML, R2: 1x60 ML, R4: 1X5ML' },
          { code: 'FEBWC100', article: 'FEBRILE ANTIGEN KIT (WIDAL)', cdt: '8X5 ML/2X1 ML'},
          { code: 'BXC0787A', article: 'D-DIMER', cdt: 'R1:1x15ML, R2:1x5ML'},
          { code: 'BXC0185A', article: 'ALP(L.S) DEA (DGKC)', cdt: 'R1:5X25ML, R2:1x10ML'},
          { code: 'BXC0501A', article: 'ASO (L.S) TURBIDIMETRIC SINGLE POINT', cdt: 'R1: 1x40ML, R2: 1x10 ML, R4: 1X1ML'},
          { code: 'BXC0203D', article: 'AST(GOT) (L.S) IFCC', cdt: 'R1: 2x100 ML, R2: 2x20 ML' },
          { code: 'BXC0201B', article: 'AST(GOT)(LYO) IFCC', cdt: 'R1:2x105ML, R2: 10x20ML'},
          { code: 'BXC0292A', article: 'CALCIUM (MONOLIQUID) ARSENAZO', cdt: 'R1: 2x125 ML, R4: 1x5ML' },
          { code: 'BXC0193A', article: 'BILLIRUBIN (L.S) TOTAL & DIRECT MANUAL', cdt: 'R1: 1x50 ML, R2: 1x 10 ML, R3: 1x100 ML, R4:1x100 ML'},
          { code: 'BXC0152B', article: 'CO2 (BICARBONATE)(MONOLIQUID)', cdt: 'R1: 10 x10 ML, R4: 1x 1 ML' },
          { code: 'BXC0113A', article: 'CREATININE ENZYMATIC (Lyo) ENZYMATIC, UV', cdt: 'R1: 1x25 ml, R2: 4x25ML, R3: 2x10ML, R4: 1x2ML'},
          { code: 'BXC0382A', article: 'CRP FULL RANGE (L.S) turbidimetric single point', cdt: 'R1: 1x40ML, R2: 1x10 ML, R4: 1x1 ML'},
          { code: 'BXC0362A', article: 'GGT (L.S) CARBOXY', cdt: 'R1: 1x60 ML, R2: 1x 12 ML' },
          { code: 'BXC0101C', article: 'GLUCOSE (MONOLIQUID) GODPAP', cdt: 'R1: 2X500, R4: 1X 5ML'},
          { code: 'BXC0421D', article: 'HDL CHOLESTEROL (L.S) DIRECT WITH CALIBRATOR', cdt: 'R1: 3x 10ML, R2: 1x10ML, R4: 1x 1ML' },
          { code: 'BXC0471A', article: 'MICROALBUMIN (L.S)', cdt: 'R1: 1x50 ML, R2:1x10ML, R4: 5x 1ML (C1-C5)' },
          { code: 'BXC0271B', article: 'TRIGLYCERIDES(MONOLIQUID) GPO-PAP', cdt: 'R1: 4x60 ML, R4: 1x5 ML' },
          { code: 'BX0603B', article: 'URIC ACID (MONOLIQUID) URICASE PAP', cdt: 'R1:1x100 ML, R4: 1x 5 ML' },
          { code: 'BX0645A', article: 'CONTROL ASO,CRP,RF', cdt: '3x 1 ML' },
          { code: 'BXC0312B', article: 'CONTROL PATHOLOGIQUE', cdt: '10 X5 ML' },
          { code: 'BXC0312A', article: 'CONTROL NORMAL', cdt: '10 X5 ML' },
          { code: 'BXC0312D', article: 'CONTROL PATHOLOGIQUE', cdt: '5X5 ML' },
          { code: 'BXC0321L', article: 'CALLIBRATION SERUM', cdt: '5x3 ML' },
          { code: 'BXC0312C', article: 'CONTROL NORMAL', cdt: '5x 5 ML' },
          { code: 'BXC0215B', article: 'GPT ALAT', cdt: 'R1: 2X100ML, R2: 2X25 ML' },
          { code: 'BXC0261B', article: 'CHOLESTEROL TOTAL', cdt: 'R1: 6X60 ML, R4: 1x5 ML' },
          { code: 'BXC0111A', article: 'CREATININE JAFF', cdt: 'R1: 1x120/R2: 1x120 ML/R4: 1X5 ML' },
      ],

      Coagulation: [
        { code: 'COAG101B', article: 'TP', cdt: '5x5 ml'},
          { code: 'COAG103B', article: 'TCK', cdt: '5x3 ml'},
          { code: 'COAG105C', article: 'FIBRINOGEN', cdt: '100 TEST'},
          { code: 'COAG104B', article: 'CACL2', cdt: '5x10 ml'},
          { code: 'COAG108A', article: 'CONTROL NIV 1', cdt: '1x1 ml'},
          { code: 'COAG109A', article: 'CONTROL NIV 2', cdt: '1x1 ml' },
          { code: 'COAG125A', article: 'CALIBRATEUR', cdt: '1x1 ml' },
    
      ],

    };
  }
};
</script>
<style scoped>
/* ======== MODE CLAIR ======== */
.produits-title {
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/reactif.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 200px 300px;
  font-size: 40px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  transition: background-color 0.3s, color 0.3s;
}

.produits-container {
  padding: 0;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  transition: background-color 0.3s, color 0.3s;
}

.produits {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5px;
  font-size: 16px;
  color: #333;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 10px;
}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

th, td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f5f5f5;
  color: #444;
  font-weight: bold;
  text-transform: uppercase;
}

td {
  color: #555;
}

th, td {
  border-right: 1px solid #ddd;
}

th:last-child, td:last-child {
  border-right: none;
}

h2 {
  color: #05305b;
  font-size: 24px;
  margin-top: 40px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
  text-align: center;
}

/* ======== RESPONSIVE ======== */
@media only screen and (max-width: 1040px) {
  .produits-title {
    padding: 100px 50px;
    font-size: 24px;
    max-width: 90%;
    margin: 0 auto;
  }

  .produits {
    padding: 10px;
    font-size: 14px;
  }

  table {
    font-size: 14px;
  }

  h2 {
    font-size: 20px;
    margin-top: 30px;
  }
}

@media only screen and (max-width: 450px) {
  .produits-title {
    padding: 50px 0;
    font-size: 18px;
    max-width: 100%;
    margin-top: 10px;
  }

  .produits {
    padding: 5px;
    font-size: 12px;
  }

  table {
    font-size: 12px;
  }

  th, td {
    padding: 10px;
  }

  h2 {
    font-size: 18px;
    margin-top: 20px;
  }

  .produits, .produits-title, table {
    box-shadow: none;
  }
}

/* ======== 🌙 MODE SOMBRE ======== */
@media (prefers-color-scheme: dark) {
  body, .produits-container {
    background-color: #0b0f14;
    color: #e6edf1;
  }

  .produits {
    background-color: #10151c;
    color: #e6edf1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
  }

  .produits-title {
    background-image: linear-gradient(
      rgba(10, 14, 18, 0.7),
      rgba(10, 14, 18, 0.7)
    ), url('C:/Users/PC MAROC/supracare_web/src/assets/reactif.jpg');
    background-size: cover;
    background-position: center;
    color: #aef7f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
  }

  .breadcrumb {
    color: #aaa;
  }

  .breadcrumb a {
    color: #73d8cf;
  }

  .breadcrumb a:hover {
    color: #00bfa5;
  }

  table {
    background-color: #141a21;
    border-color: rgba(255, 255, 255, 0.05);
    box-shadow: 0 2px 8px rgba(255, 255, 255, 0.05);
  }

  th {
    background-color: #19212a;
    color: #aef7f0;
    border-color: rgba(255, 255, 255, 0.05);
  }

  td {
    color: #d1d5db;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  th, td {
    border-right: 1px solid rgba(255, 255, 255, 0.1);
  }

  h2 {
    color: #73d8cf;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  }
}
</style>
